<template>
  <div v-if="isPending">
    <div class="sm:h-container mt-4 w-full md:mt-8">
      <Skeleton class="min-h-[22.5rem] w-full rounded-xl" />
      <Skeleton class="mx-auto mt-6 h-4 w-[250px]" />
      <Skeleton class="mt-6 h-10" />
      <Skeleton class="mx-auto mt-16 h-10 w-80" />
      <div class="h-gap my-10 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6">
        <div v-for="n in 12" :key="n">
          <Skeleton class="aspect-[4/3] h-auto w-full rounded-2xl" />
          <Skeleton class="mx-auto mt-1 h-4 w-1/2" />
        </div>
      </div>
    </div>
  </div>
  <template v-else-if="data">
    <BackgroundImage />
    <HeroIndex v-if="data.heroIndex" :data="data.heroIndex" class="mb-12" />
    <RoomCategories v-if="data.roomCategories" :data="data.roomCategories" class="mb-12" />
    <ValuePropositions v-if="data.valuePropositions" :data="data.valuePropositions" with-title dedicated-module class="mb-12" />
    <Premium v-if="data.premium" :data="data.premium" class="mb-12" />
    <SpecialOffers v-if="data.specialOffers" :data="data.specialOffers" class="mb-12" />
    <BlogGrid v-if="data.blogGridItems" :data="data.blogGridItems" class="mb-12" />
    <!--    <InfoBanner v-if="data.infoBanner" class="h-container" :text="data.infoBanner.text" :url="data.infoBanner.url" class="mb-12" />-->
    <!--    <InstagramGrid v-if="data.instagramGridItems" :data="data.instagramGridItems" class="mb-12" />-->
    <CtaBanner class="mb-12" />
    <ContentModule v-if="data.bottomText" class="mb-12">
      <div class="text" v-html="data.bottomText" />
    </ContentModule>
    <!--    <CategoriesSearch :items="data.categories" class="mb-12" />-->
    <LastViewedProductsSection class="h-container mb-12 flex flex-col items-center" />
  </template>
</template>

<script setup lang="ts">
import BlogGrid from '~/components/blog-grid/BlogGrid.vue'
import ContentModule from '~/components/content-module/ContentModule.vue'
import RoomCategories from '~/components/room-categories/RoomCategories.vue'
import CtaBanner from '~/components/cta-banner/CtaBanner.vue'
import HeroIndex from '~/components/hero-index/HeroIndex.vue'
import BackgroundImage from '~/components/background-image/BackgroundImage.vue'
import LastViewedProductsSection from '~/components/last-viewed-products-section/LastViewedProductsSection.vue'
import Skeleton from '~/components/skeleton/Skeleton.vue'

import { useHomeQuery } from '~/composables/queries/home'

const { isPending, data } = await useHomeQuery()

useHead({
  title: () => data.value?.pageTitle ?? null,
  meta: () => [data.value?.metaDescription ? { name: 'description', content: data.value.metaDescription } : undefined],
})

useCriteoHomeEvent()
</script>
